export enum Color {
  Red,
  Yellow,
  Green,
  Blue,
}
